import type { FC } from "react";

import { Form } from "@/ui/components/form/Form";
import { Input } from "@/ui/components/form/Input";
import { Password } from "@/ui/components/form/Password";
import { Column } from "@/ui/components/layout/Column";
import { Grid } from "@/ui/components/layout/Grid";
import { Button } from "@/ui/components/primitives/Button";
import {
  LOGIN_DEFAULTS,
  type TLoginProps,
} from "@/ui/components/sections/authentication/forms/Login/Login.config";
import { cn } from "@/ui/lib/utils";

export const LoginWithPassword: FC<TLoginProps> = (
  {
    email,
    password,
    submit,
    onSubmit,
    noValidate = LOGIN_DEFAULTS.noValidate,
    className,
    children,
    ...props
  },
) => {
  const {
    label: submitLabel,
    ...submitProps
  } = submit;
  const {
    onValueChange: onEmailValueChange,
    ...emailProps
  } = email;
  const {
    onValueChange: onPasswordValueChange,
    ...passwordProps
  } = password;

  return (
    <div data-component="Login">
      <Form
        {...props}
        noValidate={noValidate}
        onSubmit={onSubmit}
        className={cn(
          "w-full",
          className,
        )}
      >
        <Grid gap="4">
          <Column>
            <Input
              {...emailProps}
              name="email"
              type="email"
              autoComplete={email.autoComplete ?? "email"}
              onChange={(event) => onEmailValueChange(event.target.value)}
            />
          </Column>
          <Column>
            <Password
              {...passwordProps}
              name="password"
              autoComplete={password.autoComplete ?? "current-password"}
              onChange={(event) => onPasswordValueChange(event.target.value)}
            />
          </Column>
          { children ? (
            <Column>
              { children }
            </Column>
          ) : null }
          <Column>
            <Button
              {...submitProps}
              type="submit"
            >
              { submitLabel }
            </Button>
          </Column>
        </Grid>
      </Form>
    </div>
  );
};

LoginWithPassword.displayName = "LoginWithPassword";
